import React from 'react';

import { withRouter } from 'react-router-dom';
import { useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';

import { showConfirmAlert, showSuccessAlert, showErrorAlert } from '../../utils/alerts';

import { getApartmentsByBuilding, deleteApartment } from '../../utils/api.js';

const Apartments = (props) => {
  const { history } = props;
  const { buildingId } = props.match.params;
  const [apartments, setApartments] = useState([]);
  const [searchApartment, setSearchApartment] = useState('');

  const getAllapartments = async () => {
    try {
      const data = await getApartmentsByBuilding(buildingId);

      setApartments(data);
    } catch (error) {
      console.error('Error', error);
      showErrorAlert('Error', error.message);
    }
  };
  const confirmDeleteApartment = async ({ id }) => {
    try {
      await deleteApartment(buildingId, id);

      showSuccessAlert('Borrado Exitoso', 'Apartamento borrado con éxito');
    } catch (error) {
      console.error('Error', error);
      showErrorAlert('Error', error.message);
    }
  };

  const handleDeleteApartmentClick = (id) => {
    showConfirmAlert({
      message: 'Se borrará el apartamento y se creará uno nuevo.',
      title: 'Advertencia',
      cancelButton: 'Cancelar',
      continueButton: 'Borrar el Apartamento',
      onConfirm: () => {
        confirmDeleteApartment({ id });
      },
    });
  };

  const filteredApartments = useMemo(() => {
    return apartments.filter((apartment) => apartment.name.toLowerCase().includes(searchApartment.toLowerCase()));
  }, [apartments, searchApartment]);

  useEffect(() => {
    getAllapartments();
  }, []);

  return (
    <>
      <div>
        <div className="mb-2">
          <h2>Administrar Apartamentos</h2>
        </div>

        <div className="d-flex justify-content-start mb-4">
          <input
            type="text"
            placeholder="Buscar por Nombre"
            value={searchApartment}
            onChange={(e) => {
              const value = e.target.value;
              setSearchApartment(value);
            }}
            className="w-50 p-3 border rounded"
          />
        </div>

        <div className="table-apartments">
          <table className="table table-striped">
            <thead className="text-center font-weight-bold text-white">
              <tr>
                <th scope="col">Nombre</th>
                <th scope="col">Estado</th>
                <th scope="col">Acción</th>
              </tr>
            </thead>
            <tbody>
              {filteredApartments
                .sort((a, b) => a.name.localeCompare(b.name))
                .map((building) => {
                  const { id, name, active } = building;
                  return (
                    <tr key={id}>
                      <td className="align-middle">{name}</td>
                      <td className="align-middle">{active ? 'activo' : 'Inactivo'}</td>
                      <td className="align-middle">
                        <button
                          type="button"
                          className="btn p-1 mr-2"
                          onClick={() => {
                            handleDeleteApartmentClick(id);
                          }}
                        >
                          <span className="material-icons d-flex align-items-center">delete</span>
                        </button>
                        <button
                          type="button"
                          className="btn p-1"
                          onClick={() => {
                            history.push({
                              pathname: `/admin-dashboard/apartments/${id}/users`,
                              state: { apartmentName: name },
                            });
                          }}
                        >
                          <span className="material-icons d-flex align-items-center">person_search</span>
                        </button>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};
Apartments.propTypes = {
  buildingId: PropTypes.text,
  history: PropTypes.object,
  match: PropTypes.object,
};
export default withRouter(Apartments);
